import { useCallback, useState } from "react";
import { openCheckout } from "@konetpay/web";

const useKonetPayCheckout = () => {
  const [status, setStatus] = useState("idle");
  const [result, setResult] = useState(null);

  const open = useCallback(async (transaction, options) => {
    setStatus("open");
    const outcome = await openCheckout(transaction, options);
    setResult(outcome);
    setStatus(outcome.status);
    return outcome;
  }, []);

  return { open, status, result };
};

export default useKonetPayCheckout;
